"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
var Locale;
(function (Locale) {
    Locale["RU"] = "RU";
    Locale["EN"] = "EN";
})(Locale || (Locale = {}));
const i18nInstance = i18next_1.default.createInstance();
i18nInstance.init({
    fallbackLng: 'ru',
    lng: 'ru',
    resources: {
        en: {
            translation: require('./locales/en.json'),
        },
        ru: {
            translation: require('./locales/ru.json'),
        },
    },
    debug: false,
    interpolation: { escapeValue: false, formatSeparator: ',' },
});
const getLocalStorage = () => {
    try {
        if (typeof localStorage !== 'undefined') {
            return localStorage;
        }
    }
    catch (_e) {
        return undefined;
    }
};
const savedLanguage = ((_a = getLocalStorage()) === null || _a === void 0 ? void 0 : _a.getItem('locale')) || Locale.EN;
switch (savedLanguage) {
    case Locale.RU:
    case Locale.EN:
        i18nInstance.changeLanguage(savedLanguage.toLowerCase());
}
exports.default = i18nInstance;
